// Sign in with Google and GitHub (backend/social.py). The browser goes to the provider and comes back to
// /auth/callback/<provider> (pages/SocialCallback.jsx), which finishes what this started: a sign-in, or linking the
// provider to the signed-in account. Which of the two is kept for that one round trip in this tab.
import { api } from "@/lib/api";

export const PROVIDER_NAMES = { google: "Google", github: "GitHub" };
const KEY = "cb_social";

export async function startSocial(provider, purpose = "signin", password = "") {
  const { data } = purpose === "link"
    ? await api.post(`/auth/social/${provider}/link/start`, { password })
    : await api.post(`/auth/social/${provider}/start`);
  try { sessionStorage.setItem(KEY, JSON.stringify({ provider, purpose })); } catch {}
  window.location.assign(data.authorize_url);
}

export function takeSocialPurpose(provider) {
  let saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(KEY) || "null"); sessionStorage.removeItem(KEY); } catch {}
  return saved?.provider === provider ? saved.purpose : "signin";
}
